import React from "react";
import { SettingCard } from "./settings-card";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

type RadioSelectProps = {
  title: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  options: string[];
};

export const RadioSelect = ({
  title,
  value,
  onChange,
  options,
}: RadioSelectProps) => {
  return (
    <SettingCard title={title}>
      <FormControl component="fieldset">
        <RadioGroup row value={value} onChange={onChange} name="radio-options">
          {options.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              label={option.charAt(0).toUpperCase() + option.slice(1)}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </SettingCard>
  );
};
